var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c(
        "v-card",
        { staticClass: "groups", attrs: { flat: "" } },
        [
          _c("v-card-text", { staticClass: "groups-header" }, [
            _vm._v(
              "\n      Editar: Rateio " + _vm._s(_vm.item.name) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "group-item" },
            [
              _c(
                "div",
                { staticClass: "config" },
                [
                  _c("p", [
                    _vm._v("Tipo de rateio: "),
                    _c("span", [_vm._v("*")]),
                  ]),
                  _vm._v(" "),
                  _c("AppRadioBox", {
                    attrs: { options: _vm.apportionmentTypeOptions, row: "" },
                    model: {
                      value: _vm.group.apportionmentType,
                      callback: function ($$v) {
                        _vm.$set(_vm.group, "apportionmentType", $$v)
                      },
                      expression: "group.apportionmentType",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "config" },
                [
                  _c("p", [
                    _vm._v("Visível para o vendedor: "),
                    _c("span", [_vm._v("*")]),
                  ]),
                  _vm._v(" "),
                  _c("AppRadioBox", {
                    attrs: { options: _vm.visibleToSellerOptions, row: "" },
                    model: {
                      value: _vm.group.visibleToSeller,
                      callback: function ($$v) {
                        _vm.$set(_vm.group, "visibleToSeller", $$v)
                      },
                      expression: "group.visibleToSeller",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "config" },
                [
                  _c("p", [_vm._v("Acelerador: "), _c("span", [_vm._v("*")])]),
                  _vm._v(" "),
                  _c("AppRadioBox", {
                    attrs: { options: _vm.acceleratorTypeOptions, row: "" },
                    model: {
                      value: _vm.group.acceleratorType,
                      callback: function ($$v) {
                        _vm.$set(_vm.group, "acceleratorType", $$v)
                      },
                      expression: "group.acceleratorType",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "config" },
                [
                  _c("AppSelectGroup", {
                    attrs: {
                      items: _vm.partners,
                      customFilter: _vm.customFilter,
                      disabled: _vm.group.allPartners,
                      v: _vm.$v.group.partnerIds,
                      label: "Selecione parceiros",
                      placeholder: "Selecione os parceiros",
                      "on-text": "name",
                      "on-value": "_id",
                      clearable: "",
                      multiple: "",
                    },
                    on: { blur: _vm.$v.group.partnerIds.$touch },
                    model: {
                      value: _vm.group.partnerIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.group, "partnerIds", $$v)
                      },
                      expression: "group.partnerIds",
                    },
                  }),
                  _vm._v(" "),
                  _c("AppSwitch", {
                    attrs: { label: "Selecionar todos" },
                    on: { change: _vm.includeAllPartnersIds },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("ResponsiblesConfig", {
                attrs: { group: _vm.group, type: "edit" },
                on: {
                  groupOptions: _vm.getGroupOptions,
                  isInvalidForm: _vm.getIsInvalidForm,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-card", { staticClass: "mt-1", attrs: { flat: "" } }, [
        _c(
          "div",
          { staticClass: "btn-footer" },
          [
            _c(
              "v-btn",
              { attrs: { color: "secondary" }, on: { click: _vm.cancel } },
              [_vm._v("\n        Cancelar\n      ")]
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: { disabled: _vm.disabledSaveBtn, color: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.save()
                  },
                },
              },
              [_vm._v("\n        Salvar\n      ")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }